export const BonusGameGridView = {
	size: 100,
	gap: 0,
	name: 'BonusGameGridView',
	padding: {
		top: 5,
		bottom: 5,
		left: 5,
		right: 5,
		portrate: {
			top: 3,
			bottom: 3,
			left: 3,
			right: 3
		}
	},
	main: [
		{
			name: 'empty',
			size: 5
		},
		{
			name: 'bonusgamegrid_left',
			size: 65,
			type: 'PortrateGridController',
			config: {
				name: 'bonus_left',
				size: 100,
				gap: 0,
				main: [
					{
						name: 'empty',
						size: 10
					},
					{
						name: 'BonusItems',
						size: 18,
						align: 'bottom_left',
						bounds: {
							width: 1144,
							height: 190
						}
					}
				]
			}
		},
		{
			name: 'empty',
			size: 2.5
		},
		{
			name: 'bonusgamegrid_right',
			size: 27.5,
			type: 'PortrateGridController',
			config: {
				name: 'bonus_right',
				size: 100,
				gap: 0,
				align: 'left',
				padding: {
					left: 12
				},
				main: [
					{
						name: 'empty',
						size: 15
					},
					{
						name: 'fg_holder',
						size: 35,
						//height: 90,
						align: 'right-center',
						bounds: {
							width: 300,
							height: 300
						}
					},
					{
						name: 'empty',
						size: 8
					},
					{
						name: 'win_bg_wrapper',
						align: 'bottom',
						size: 8,
						bounds: {
							width: 373,
							height: 109
						}
					},
					{
						name: 'empty',
						size: 12
					},
					{
						name: 'btn_holder',
						size: 15,
						align: 'right_center',
						bounds: {
							width: 275,
							height: 160
						}
					}
				]
			}
		}
	],
	landscape: [
		{
			name: 'empty',
			size: 5
		},
		{
			name: 'bonusgamegrid_left_landscape',
			size: 65,
			type: 'PortrateGridController',
			config: {
				name: 'bonus_left',
				size: 100,
				gap: 0,
				main: [
					{
						name: 'empty',
						size: 10
					},
					{
						name: 'BonusItems',
						size: 18,
						align: 'bottom_left',
						bounds: {
							width: 1144,
							height: 190
						}
					}
				]
			}
		},
		{
			name: 'empty',
			size: 2
		},
		{
			name: 'bonusgamegrid_right_landscape',
			size: 29,
			type: 'PortrateGridController',
			config: {
				name: 'bonus_right',
				size: 100,
				gap: 0,
				align: 'left',
				padding: {
					left: 12
				},
				main: [
					{
						name: 'empty',
						size: 15
					},
					{
						name: 'fg_holder',
						size: 35,
						align: 'right-center',
						bounds: {
							width: 300,
							height: 300
						}
					},
					{
						name: 'empty',
						size: 8
					},
					{
						name: 'win_bg_wrapper',
						align: 'center',
						size: 8,
						bounds: {
							width: 373,
							height: 109
						}
					},
					{
						name: 'empty',
						size: 12
					},
					{
						name: 'btn_holder',
						size: 15,

						align: 'right_center',
						bounds: {
							width: 275,
							height: 160
						}
					}
				]
			}
		}
	],
	portrate: [
		{
			name: 'BonusItems',
			size: 18,
			bounds: {
				width: 1140,
				height: 40
			}
		},
		{
			name: 'empty',
			size: 39
		},
		// {
		// 	name: 'bonus_portrait',
		// 	size: 21,
		// 	type: 'LandscapeGridController',
		// 	maxWidth: 'reel',
		// 	config: {
		// 		name: 'bonus_mid',
		// 		size: 100,
		// 		maxWidth: 'reel',
		// 		gap: 0,
		// 		main: [

		{
			name: 'fg_holder',
			visible: false
		},
		{ name: 'empty', size: 6 },
		// {
		// 	name: 'fg_holder',
		// 	size: 14,
		// 	//height: 90,
		// 	align: 'center',
		// 	bounds: {
		// 		width: 300,
		// 		height: 300
		// 	}
		// },
		{
			name: 'win_bg_wrapper',
			align: 'center',
			size: 10,
			bounds: {
				width: 373,
				height: 109
				// offsetY: 20
				// offsetX: 10
			}
		},
		// {
		// 	name: 'empty',
		// 	size: 1
		// },

		// ]
		// }
		// },

		{
			name: 'empty',
			size: 14
		},
		{
			name: 'btn_holder',
			size: 16,
			align: 'center',
			bounds: {
				width: 245,
				height: 160
			}
		}
	]
};
